module.exports = __webpack_public_path__ + "img/jeopardy1.e51519fb.webp";